import Flickity from 'flickity';
import "flickity/dist/flickity.min.css";

const defaultOps = {
  accessibility: false,
  adaptiveHeight: true,
  pauseAutoPlayOnHover: true,
  autoPlay: 3000,
  cellAlign: "center",
  cellSelector: ".houseCard__imageSlide",
  contain: false,
  draggable: true,
  dragThreshold: 0,
  groupCells: false,
  initialIndex: 0,
  prevNextButtons: true,
  percentPosition: true,
  pageDots: false,
  resize: true,
  setGallerySize: true,
  wrapAround: true
};

const Slider = () => {
  const element = document.querySelector(".houseCard__image--has-gallery");
  const elements = document.querySelectorAll('.houseCard__image--has-gallery')

  const init = () => Array.prototype.forEach.call(elements, (element) => {
    new Flickity(element, { ...defaultOps })
  });

  if (typeof element != "undefined" && element != null)
    init()
};

export default Slider;


// WEBPACK FOOTER //
// ./src/js/app/components/Slider.js